const messages = {
  popup: 'نمایش به صورت لیست کشویی',
  options: 'گزینه‌ها',
  addField: 'افزودن فیلد',
  required: 'الزامی',
  inputType: 'نوع ورودی',
  withValue: 'همراه با مقدار',
  fieldTitle: 'عنوان فیلد',
  maxAnswers: '‌حداکثر تعداد پاسخ',
  selectAnInputType: 'نوع ورودی مورد نظر را انتخاب کنید...',
  withoutLimitation: 'بدون محدودیت',
  addOptionIfItIsNecessary: 'گزینه‌ای را در صورت نیاز اضافه کنید',
  protection: 'محافظت شده',
  protection_View: 'فقط به کاربر با دسترسی گزارش نمایش داده شود',
  protection_Edit: 'فقط کاربر با دسترسی تغییر داده بتواند ویرایش کند',
  protection_null: 'محافظت نشده',
  flags: 'ویژگی های اضافی',
};

export const inputTypes: { [type: string]: string } = {
  text: 'متن',
  date: 'تاریخ',
  time: 'ساعت',
  number: 'عدد',
  duration: 'مدت زمان',
};

export default messages;
